import { t } from "i18next";
import PdfIcon from "@assets/icons/pdf.svg";
import WebIcon from "@assets/icons/earth.svg";
import YoutubeIcon from "@assets/icons/youtube.svg";

export enum ROLES {
  USER = "user",
  ASSISTANT = "assistent",
}

export enum ERROR_TYPES {
  INVALID = "invalid",
  NETWORK_ERROR = "networkError",
  NO_INTERNET = "noInternet",
  CUSTOM = "custom",
  DEFAULT = "default",
}

export enum INPUT_TYPES {
  FORM = "@from",
}

/**
 * Centralized polling intervals for chat API calls (in milliseconds)
 * Modify these values to change polling behavior across the application
 */
export const CHAT_RESPONSE_STREAM_TIME = {
  /** Interval between regular chat API polling calls (fetchChat) - 1000ms */
  REFETCH_INTERVAL: 1000,
  /** 
   * Counter threshold for first refetch wait (used with currentInterval counter)
   * If currentInterval > FIRST_REFETCH_WAIT, the first fetch will be triggered
   */
  FIRST_REFETCH_WAIT: 3,
  /** Interval between verify-chat API polling calls - 1000ms (1 second) */
  VERIFY_CHAT_POLLING_INTERVAL: 1000,
  /** 
   * Maximum number of consecutive API pollings with the same status (excluding status 3)
   * before triggering a timeout error. If 100 consecutive pollings return the same status
   * (except status 3), polling will stop and an error will be displayed.
   */
  MAX_CONSECUTIVE_SAME_STATUS: 40,
} as const;

export const VALIDATION_STATES = {
  PENDING: "pending",
  SUCCESS: "success",
  ERROR: "error",
  NONE: "none",
};

export const enum QUERY_TYPE {
  PDF = "pdf",
  WEBSITE = "website",
  YOUTUBE = "youtube",
  DEEP_SEARCH = "deepsearch",
}

export const chatHeaderData = () => [
  {
    title: t("common:chat.addPdfLink"),
    icon: PdfIcon,
    value: QUERY_TYPE.PDF,
  },
  {
    title: t("common:chat.addWebLink"),
    icon: WebIcon,
    value: QUERY_TYPE.WEBSITE,
  },
  {
    title: t("common:chat.addYoutubeLink"),
    icon: YoutubeIcon,
    value: QUERY_TYPE.YOUTUBE,
  },
];
